import { watch as m, unref as p } from "vue";
import { debugWarn as n } from "./index588.js";
const c = ({ from: e, replacement: t, scope: r, version: i, ref: o, type: a = "API" }, s) => {
  m(
    () => p(s),
    (d) => {
      d && n(
        r,
        `[${a}] ${e} is about to be deprecated in version ${i}, please use ${t} instead.
For more detail, please visit: ${o}
`
      );
    },
    {
      immediate: !0
    }
  );
};
export {
  c as useDeprecated
};
